import React, {
    FC,
    createContext,
    useEffect,
    useState,
    ReactNode,
    useRef,
    useMemo,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    Button,
    Space,
    Typography,
    Table,
    PaginationProps,
    ConfigProvider,
    List,
    Skeleton,
    Spin,
    Tabs,
    Empty,
    message,
    Modal,
    Popover,
    Input,
    InputRef,
    Radio,
    Popconfirm,
    Dropdown,
    Menu,
    Tag,
} from 'antd'
import {
    PlusOutlined,
    SearchOutlined,
    DownloadOutlined,
    ExportOutlined,
    QuestionCircleTwoTone
} from '@ant-design/icons'
import zhCN from 'antd/es/locale/zh_CN'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import {
    exportReviewExcel,
    exportContributionExcel,
    getFile,
    getFileList,
    getOnlineReview,
    relevantTechProj,
    getOnlineReviewById,
    delOnlineReview,
    exportReviewInfoExcel,
    updateReviewResult,
} from '@/services/progress.service'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import moment from 'moment'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import { IFileRes, IAddRelatedTechProject } from '@/store/models/process.model'
import { downloadFile, getUuid, hideLoading, showLoading } from '@/utils/util'
import ResizableTable from '@/components/resizableTable'
import ReviewSearchPop, { ISearchData } from '@/pages/processMana/components/reviewSearchPop'
import { IAppState } from '@/store/reducers'
import _ from 'lodash'
import Nav from '@/components/nav'
import SelectProject from '@/pages/table2Mana/components/selectProjects'
import { validateAuth } from '@/utils/auth'
import { ETechnologyContribution, ETechnologyLeadership } from '@/types'
import { FilterConfirmProps } from 'antd/es/table/interface'
import ReviewLogs from './ReviewLogs'
import ReviewProgress from './processMana/components/progressDrawer'
import AiSearchDrawer from './processMana/components/aiSearchDrawer'


interface childrenType {
    title: string;
    dataIndex: string;
    key: string;
    editable?: boolean;
    className?: string;
    width?: number;
    ellipsis: { showTitle: boolean };
    filters?: {
        text: string;
        value: number;
    }[];
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    onFilter?: (value: string, record: any) => boolean;
    render?: any;
}
interface IColProperty {
    title?: ReactNode | string;
    className?: string;
    editable?: boolean;
    dataIndex?: string;
    children?: childrenType[];
    filters?: {
        text: string;
        value: string;
    }[];
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    onFilter?: (value: string | number | boolean, record: any) => boolean;
}
interface SelectedProject {
    project: string;
    project_name: string;
    project_select: string[]; // Assuming project_select is an array of strings
}
// interface Project {
//     projectNo: string;
//     almProjectId: string;
//     projectId: string;
//     // Add other properties if needed
// }
type EditableTableProps = Parameters<typeof Table>[0];
type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>;

export const DrawerShowContext = createContext<{
    showSearchPop: boolean;
    setShowSearchPop: any;
    closeCallback: any;
    formData: ISearchData,
}>({
    showSearchPop: false,
    setShowSearchPop: null,
    closeCallback: null,
    formData: {},
})
const { TabPane } = Tabs

const TechReviewProgressPage: FC = React.memo(() => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()

    const authInfo = useSelector((state: IAppState) => state.auth.authInfo)
    const userInfo = useSelector((state: IAppState) => state.auth.userInfo)
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const login = useSelector((state: IAppState) => state.auth.userInfo?.login)
    const [exportLoading, setExportLoading] = useState(false)
    const [tabDataObj, setTabDataObj] = useState<
        {
            onlineReviewLs: any[];
            tableKey: string;
            searchCont: any;
            paginationInfo: {
                pageNo: number;
                pageSize: number;
                total: number;
            };
        }[]
    >([
        {
            onlineReviewLs: [],
            tableKey: '1',
            searchCont: {},
            paginationInfo: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
        },
        {
            onlineReviewLs: [],
            tableKey: '2',
            searchCont: {},
            paginationInfo: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
        },
        {
            onlineReviewLs: [],
            tableKey: '4',
            searchCont: {},
            paginationInfo: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
        },
        {
            onlineReviewLs: [],
            tableKey: '3',
            searchCont: {},
            paginationInfo: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
        },
    ])
    const [loaded, setLoaded] = useState(false)
    const [editResultOpen, setEditResultOpen] = useState(false)
    const searchInput = useRef<InputRef>(null)
    const [searchText, setSearchText] = useState('')
    const [searchedColumn, setSearchedColumn] = useState('')
    // modal弹窗内部loading
    const [modalLoading, setModalLoading] = useState(false)
    const [curReviewResValue, setCurReview] = useState<Record<string, any>>({
        reviewResult: null,
        id: ''
    })
    // ai 搜索
    const [aiSearchDrawerOpen, setAiSearchDrawerOpen] = useState(false)
    // 日志抽屉
    const [logDrawerOpen, setLogDrawerOpen] = useState(false)
    // 评审进度抽屉
    const [progressDrawerOpen, setProgressDrawerOpen] = useState(false)
    const localCurTabBigScreen = localStorage.getItem('curTab')
    const historyTabIndex =
        localCurTabBigScreen !== null ? localCurTabBigScreen : '1'
    const [curTab, setCurTab] = useState<string>('' + historyTabIndex)
    const [tabData, setTabData] = useState<Record<string, any>>({})
    const [showSearchPop, setShowSearchPop] = useState(false)
    const [refreshUuid, setRefreshUuid] = useState('1')
    const [, setWinW] = useState<number>(0)
    const [winH, setWinh] = useState<number>(0)

    const [showSelectProjects, setShowSelectProjects] = useState(false)
    const [selectedProject, setSelectedProject] = useState<SelectedProject>({
        project: '',
        project_name: '',
        project_select: [],
    })

    // const [projectInfo, setProjectInfo] = useState<any>(null)
    // const formRef = createRef<FormInstance>()
    const selectProjectCallBack = async (projectInfo: any[]) => {
        try {
            console.log(selectedProject.project, 'RECORD ID')
            // const current_date = new Date()

            const newProjectInfo = projectInfo.map((item) => ({
                projectName: item.projectName,
                projectNo: item.almProjectId,
                approvalDate: item.actualStartDate,
                estimateClosedDate: item.estimatedEndDate,
                actualClosedDate: item.actualEndDate,
                projectResult: item.finalResult,
                techReviewId: Number(selectedProject.project),
            }))

            console.log('Payload:', JSON.stringify(newProjectInfo))

            // newProjectInfo.forEach(item => {
            //     console.log(typeof item.techReviewId)  // Check if it's a number or string
            // })

            console.log('Prepared data to send:', newProjectInfo)

            const response = await relevantTechProj(newProjectInfo)

            console.log('API Response:', response)
            history.push(
                `/relevantByFeedBackList?progressId=${selectedProject?.project}&name=${selectedProject?.project_name}&type=${curTab}`
            )
        } catch (error) {
            console.error('Error saving project information:', error)
            alert('Failed to save project information. Please try again.')
        }
    }

    const popConfirmBtn = (title: string, onConfirm: () => void) => {
        return (
            <Popconfirm
                title={joinTranslatedStrings(t('confirm'), title)}
                onConfirm={onConfirm}
                okText={t('confirm')}
                cancelText={t('cancel')}
            >
                <Text className="txt_blue hand" title={title} >
                    {title}
                </Text>
            </Popconfirm>
        )
    }

    const onSelectProject = async (projId: string, projName: string) => {
        try {
            // Fetch the project details by ID
            const res = await getOnlineReviewById(+projId)
            const prjList = (res?.projectList || []) as IAddRelatedTechProject[] // Ensure type is an array of IAddRelatedTechProject

            console.log(prjList)

            // Transform prjList into string[] (e.g., extracting project names)
            const projectSelect: string[] = prjList
                .map((proj) => proj.projectName) // Extract project names
                .filter(Boolean) as string[] // Ensure no undefined/null values in the resulting array

            console.log(projectSelect, 'selected')

            // Set the selected project
            setSelectedProject({
                project: projId,
                project_name: projName,
                project_select: projectSelect, // Pass the transformed array
            })

            // Show the project select component
            setShowSelectProjects(true)
        } catch (error) {
            // Handle errors
            console.error('Error fetching project details:', error)

            // Optionally hide the select if an error occurs
            setShowSelectProjects(false)
        }
    }

    // pageSize 变更后，会重复触发 pageChange 事件
    // const pageSizeChanged = useRef<boolean>(false)

    const { Text } = Typography
    const approvalType = [
        {
            id: 1,
            label:
                t('technicalPlan') +
                (i18n.language !== 'zh' ? ' ' : '') +
                t('approval'),
        },
        {
            id: 2,
            label:
                t('technicalDefineAndResearchTaskBook') +
                (i18n.language !== 'zh' ? ' ' : '') +
                t('approval'),
        },
        {
            id: 4,
            label:
                t('buTMTApproveTech') +
                (i18n.language !== 'zh' ? ' ' : '') +
                t('approval'),
        },
        {
            id: 3,
            label:
                t('technicalAchievementDelivery') +
                (i18n.language !== 'zh' ? ' ' : '') +
                t('approval'),
        },
    ]
    const findLabel = (arr: any[], id: number) =>
        arr?.find((item: any) => item.id === id)?.label ?? ''

    const technologicalLeadershipArr = useRef([
        {
            label: t('leadership'),
            id: ETechnologyLeadership.LEADING,
        },
        // {
        //     label: t('homeleadership'),
        //     id: ETechnologyLeadership.HOME_LEADING,
        // },
        {
            label: t('equalize'),
            id: ETechnologyLeadership.EQUAL,
        },
        {
            label: t('trail'),
            id: ETechnologyLeadership.TRAIL,
        },
    ])
    const technicalContributionArr = useRef([
        {
            label: t('innovationSellingPoint'),
            id: ETechnologyContribution.INNOVATION,
        },
        {
            label: t('keySellingPoint'),
            id: ETechnologyContribution.KEY,
        },
        {
            label: t('secondarySellingPoints'),
            id: ETechnologyContribution.SECONDARY,
        },
        {
            label: t('infrastructure'),
            id: ETechnologyContribution.BASIC,
        },
    ])
    const labelArr = [
        t('core') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
        t('key') + (i18n.language !== 'zh' ? ' ' : '') + t('technology'),
        t('basicTechnology'),
        t('reserveTechnology'),
    ]

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const batchDownloadFile = async (files: IFileRes[]) => {
        showLoading(<Spin size="large" />)
        const promiseArr: Promise<{
            data: any;
            type: string;
            suffix: string;
        }>[] = []
        files.forEach(async (item) => {
            promiseArr.push(getFile(item.id))
        })
        const resArr = await Promise.all(promiseArr).finally(() => {
            hideLoading()
        })
        resArr.forEach((res, index) => {
            const fileObj = files[index]
            downloadFile(res, fileObj.fileName)
        })
    }


    const deleteTech = async (id: number) => {
        try {
            await delOnlineReview(id)
            message.success('删除成功')
            getLs()
        } catch (error) {
            message.error('删除失败')
            console.error('Error deleting tech:', error)
        }
    }

    const getUserLogin = (creator: string) => {
        const rs = creator.match(/[^(][a-zA-Z0-9]+(?=\))/g)
        return rs ? rs[0] : creator
    }

    // 校验权限
    const validateAuthByKey = (key: string) => validateAuth(authInfo, key)

    // 是否评审中
    const isProposalPending = (record: any) => record.reviewResult === null

    // 是否当前用户发起
    const isCurrentUserCreator = (record: any) => getUserLogin(record.creator) === login

    // 查看评审进度
    const handleViewProgressBtn = (record: any) => {
        setProgressDrawerOpen(true)
        setCurReview(record)
    }

    // 是否是当前负责人
    const isCurrentLeader = (record: any) => {
        const { tmtUserList } = record
        if (tmtUserList?.length === 0) {
            return false
        }
        return tmtUserList?.some((user: any) => user.tmtUser === login)
    }

    // 是否参会的评委
    const isCurrentJudges = (record: any) => {
        const { tmtUserList } = record
        if (tmtUserList?.length === 0) {
            return false
        }
        return tmtUserList?.some((user: any) => user.tmtUser === login && user.judgesType === 1 && user.isParticipate === true)
    }

    const isCurrentITMT = (record: any) => {
        const { itmtUserList } = record
        if (itmtUserList?.length === 0) {
            return false
        }
        return itmtUserList?.some((user: any) => user.login === login)
    }

    // 管理员编辑
    const editResultByAdminHandle = (record: any) => {
        setEditResultOpen(true)
        setCurReview({
            reviewResult: record.reviewResult,
            id: record.id,
        })
    }

    // 封装拼接字符串的函数
    const joinTranslatedStrings = (...translations: string[]) => {
        return translations.join(i18n.language !== 'zh' ? ' ' : '')
    }

    const viewButton = (_: any, record: any) => {
        // const isSameOrBefore = moment().isSameOrBefore(record.dueDate, 'day')
        const isSameOrBeforeReviewEnd = moment().isSameOrBefore(
            record.tmtReviewDueDate,
            'day'
        )
        return (
            <div className="txt_btn">
                {/* 未反馈，时间不能超过截止日期当天 */}
                {/* {curTab !== '4' && record.reviewResult === null&&*/}
                {/* (authInfo && Reflect.has(authInfo, 'techReviewEdit'))
                        || ( getUserLogin(record.creator) === login)
                     &&
                    <Text 
                        className={(record.reviewResult === null && isSameOrBefore) ? 'txt_blue hand' : ''}
                        onClick={() => {
                            if (record.reviewResult === null && isSameOrBefore) {
                                history.push(`/techReviewEdit?id=${record.id}&type=${curTab}`)
                            }
                        }}
                        title={(record.reviewResult === null && isSameOrBefore) ? t('edit') : ''}
                    >
                        {t('edit')}
                    </Text>
                */}

                {(validateAuthByKey('techReviewEdit') || isCurrentUserCreator(record)) && (
                    <Text
                        className="txt_blue hand"
                        onClick={() => {
                            window.open(`/techReviewEdit?id=${record.id}&type=${curTab}`, '_blank')
                        }}
                        title={t('edit')}
                    >
                        {t('edit')}
                    </Text>
                )}

                {((authInfo && Reflect.has(authInfo, 'techReviewEdit')) ||
                    getUserLogin(record.creator) === login) && (
                    <Text
                        className="txt_blue hand"
                        onClick={() => {
                            setLogDrawerOpen(true)
                            setCurReview({
                                ...curReviewResValue,
                                ...record,
                            })
                        }}
                        title={t('review log records')}
                    >
                        {t('review log records')}
                    </Text>
                )}
                {/* 技术规划评审相关性反馈 */}
                {curTab !== '4' &&
                    isSameOrBeforeReviewEnd &&
                    !record.isPlReview &&
                    record.reviewResult === null &&
                    (validateAuthByKey('relevantReview') || isCurrentITMT(record)) &&
                    record.openRelevant && (
                    <Text
                        className="txt_blue hand"
                        onClick={() => {
                            // Save current state to sessionStorage before navigation
                            sessionStorage.setItem('techReviewTabData', JSON.stringify({
                                tabDataObj,
                                curTab
                            }))

                            history.push(
                                `/relevantReview?progressId=${record.id}&type=${curTab}`
                            )
                        }}
                        title={t('feedback')}
                    >
                        {/* <DeploymentUnitOutlined style={{ fontSize: 16 }} /> */}
                        {t('feedback')}
                    </Text>
                )}

                {/* 发起评审：评委确认，选择参会人员 */}
                {curTab !== '4' &&
                    !record.isPlReview &&
                    record.reviewResult === null &&
                    record.openRelevant === false &&
                    record.openReview === null &&
                    (isCurrentUserCreator(record) ||
                        validateAuthByKey('relevantReviewSelectPerson')) && (
                    <Text
                        className="txt_blue hand"
                        onClick={() => {
                            history.push(
                                `/relevantReviewSelectPerson?progressId=${record.id}&type=${curTab}&write=true`
                            )
                        }}
                        title={t('reviewConfirm')}
                    >
                        {/* <GoldOutlined style={{ fontSize: 16 }} /> */}
                        {t('reviewConfirm')}
                    </Text>
                )}
                {/* Add related Projects */}
                {curTab === '3' &&
                    record.reviewResult === true &&
                    getUserLogin(record.creator) === login && (
                    <Text
                        className="txt_blue hand"
                        onClick={() => {
                            onSelectProject(record.id, record.proposalName)
                        }}
                        title={t('addRelatedProjects')}
                    >
                        {t('addRelatedProjects')}
                    </Text>
                )}
                {/* 二次评审 */}
                {validateAuthByKey('techReviewMore') &&
                    isCurrentUserCreator(record) &&
                    record.reviewResult === false &&
                    record.children === null &&
                    record.parent === null && (
                    <Text
                        className="txt_blue hand"
                        onClick={() => {
                            if (curTab === '4') {
                                history.push(
                                    `/techReviewEdit?id=${record.id}&type=${curTab}&more=true`
                                )
                            } else {
                                history.push(
                                    `/techReviewMore?id=${record.id}&type=${curTab}`
                                )
                            }
                        }}
                        title={
                            t('submit') +
                                (i18n.language !== 'zh' ? ' ' : '') +
                                t('secondReview') +
                                (i18n.language !== 'zh' ? ' ' : '') +
                                t('apply')
                        }
                    >
                        {/* <UserSwitchOutlined style={{ fontSize: 16 }} /> */}
                        {t('submit') +
                                (i18n.language !== 'zh' ? ' ' : '') +
                                t('secondReview') +
                                (i18n.language !== 'zh' ? ' ' : '') +
                                t('apply')}
                    </Text>
                )}
                {/* 评审反馈 */}
                {/* （BU TMT批准技术课题 时直接跳转） */}
                {record.reviewResult === null &&
                    (validateAuthByKey('reviewStar') || isCurrentJudges(record)) &&
                    (curTab === '1' || curTab === '2') &&
                    record.openReview && (
                    <Text
                        className="txt_blue hand"
                        onClick={() => {
                            history.push(
                                `/reviewStar?progressId=${record.id}&type=${curTab}&write=true`
                            )
                        }}
                        title={t('startReview')}
                    >
                        {t('startReview')}
                    </Text>
                )}
                {/* PL TMT评审 或 成果将会评审 */}
                {/* 如果是 PL TMT评审阶段，则只有PL TMT 才能评审，TMT 不能评审 */}
                {/* 如果不是PL TMT评审阶段，则PL TMT 不能评审， TMT才能评审 */}
                {/* isPLReview === null时 表示是前两种类型，走上面打星流程,
                    1 表示是PL TMT评审流程, 0 表示 TMT 评审流程 */}

                {record.reviewResult === null &&
                    (isCurrentLeader(record) || validateAuthByKey('reviewStar')) &&
                    (curTab === '3' || curTab === '4') && (
                    <Text
                        className="txt_blue hand"
                        onClick={() => {
                            history.push(
                                `/reviewStar?progressId=${record.id}&type=${curTab}&write=true`
                            )
                        }}
                        title={t('startReview')}
                    >
                        {/* <StarOutlined style={{ fontSize: 16 }} /> */}
                        {t('startReview')}
                    </Text>
                )}
                {/* 二次评审，评委确认是否参加二次评审 */}
                {curTab !== '4' &&
                    record.reviewResult === null &&
                    record.openRelevant === null &&
                    (authInfo &&
                    Reflect.has(authInfo, 'reviewStar') || isCurrentLeader(record)) && (
                    <Text
                        className="txt_blue hand"
                        onClick={() => {
                            history.push(
                                `/reviewStar?progressId=${record.id}&type=${curTab}&write=true`
                            )
                        }}
                        title={t('auditOrNot')}
                    >
                        {/* <StarOutlined style={{ fontSize: 16 }} /> */}
                        {t('auditOrNot')}
                    </Text>
                )}
                {/* 查看报告 */}
                <Text
                    className="txt_blue hand"
                    title={t('viewFeedback')}
                    onClick={() => {
                        // Save current state to sessionStorage before navigation
                        sessionStorage.setItem('techReviewTabData', JSON.stringify({
                            tabDataObj,
                            curTab
                        }))

                        // history.push(`/relevantByFeedBackList?progressId=${record.id}&name=${record.proposalName}&type=${curTab}`)
                        // 新开页面
                        window.open(`/relevantByFeedBackList?progressId=${record.id}&name=${record.proposalName}&type=${curTab}`, '_blank')

                    }}
                >
                    {t('viewFeedback')}
                </Text>
                {/* 创建课题 */}
                {curTab === '1' &&
                    ((authInfo && Reflect.has(authInfo, 'createTech')) ||
                        getUserLogin(record.creator) === login) &&
                    record.reviewResult &&
                    record.techProjects.length === 0 && (
                    <Text
                        className="txt_blue hand"
                        title={t('createTech')}
                        onClick={() => {
                            // Save current state to sessionStorage before navigation
                            sessionStorage.setItem('techReviewTabData', JSON.stringify({
                                tabDataObj,
                                curTab
                            }))

                            history.push(
                                `/projectInfoAdd?workGroupId=${record.workGroup.id}&techOnlineReviewId=${record.id}`
                            )
                        }}
                    >
                        {t('createTech')}
                    </Text>
                )}
                {/* 已有课题，则显示 */}
                {/* {authInfo && Reflect.has(authInfo, 'viewTech') &&
                    record.reviewResult && record.techProjects.length > 0 &&
                    <Text className='txt_blue hand' 
                        title={t('viewTech')}
                        onClick={() => {
                            dispatch(setEdit2Data({
                                ...record.techProjects[0]
                            }))
                            history.push(`/projectInfoView?workGroupId=${record.workGroup.id}&projectId=${record.techProjects[0].id}&isView=true`)
                        }}
                    ><CompassOutlined style={{ fontSize: 16 }} /></Text>
                } */}
                {/* 下载附件 */}
                {((authInfo && Reflect.has(authInfo, 'downloadAttach')) || getUserLogin(record.creator) === login) && (
                    popConfirmBtn(t('downloadFile'), () => batchDownloadFile(record.files))
                )}
                {/* 删除按钮 */}
                {authInfo && Reflect.has(authInfo, 'deleteTechView') && (
                    popConfirmBtn(t('delete'), () => deleteTech(record.id))
                )}
                {/* 一键催办  */}
                {/* {
                    isProposalPending(record) && (isCurrentUserCreator(record) || validateAuthByKey('oneKey_Remind')) && (
                        <Text className="txt_blue hand" title={t('oneClickUrge')} onClick={() => handleClickUrge(record)}>
                            {t('oneClickUrge')}
                        </Text>
                    )
                } */}
                {/* 查看评审进度  */}
                {
                    isProposalPending(record) && (isCurrentUserCreator(record) || validateAuthByKey('oneKey_Remind')) && (
                        <Text className="txt_blue hand" title={t('review progress')} onClick={() => handleViewProgressBtn(record)}>
                            {t('review progress')}
                        </Text>
                    )
                }
                {/* 修改评审结果（管理员）  */}
                {
                    (validateAuthByKey('review_result_modify')) && (
                        <Text className="txt_blue hand" title={joinTranslatedStrings(t('modify'), t('reviewResult'))} onClick={() => editResultByAdminHandle(record)}>
                            {joinTranslatedStrings(t('modify'), t('reviewResult'))}
                        </Text>
                    )
                }
            </div>
        )
    }
    const viewAttach = (value: IFileRes[]) => {
        return value.length ? (
            <List
                itemLayout="horizontal"
                dataSource={value}
                renderItem={(item) => (
                    <List.Item
                        className="attach_name"
                        actions={
                            (authInfo && Reflect.has(authInfo, 'downloadAttach')) ||
                                getUserLogin(item.creator) === login
                                ? [
                                    <Text
                                        className="txt_blue hand"
                                        title={t('downloadFile')}
                                        onClick={async () => {
                                            showLoading(<Spin size="large" />)
                                            const res = await getFile(item.id).finally(() => {
                                                hideLoading()
                                            })
                                            downloadFile(res, item.fileName)
                                        }}
                                    >
                                        <DownloadOutlined style={{ fontSize: 16 }} />
                                    </Text>,
                                    // <Text className='txt_blue hand' title={t('previewFile')} onClick={async () => {
                                    //     autoClick(`${UploadAPI}/onlinePreview?filePath=${item?.filePath}`)
                                    // }}><FileSearchOutlined style={{ fontSize: 16 }} /></Text>
                                ]
                                : []
                        }
                    >
                        <Skeleton avatar title={false} loading={false} active>
                            <List.Item.Meta
                                title={
                                    <span className="word" title={item.fileName}>
                                        {item.fileName}
                                    </span>
                                }
                            />
                        </Skeleton>
                    </List.Item>
                )}
            />
        ) : (
            ''
        )
    }

    const getSearchByKey = (key: string) => {
        const index = approvalType.findIndex(
            (type) => type.id === Number(curTab)
        )
        const arr = [...tabDataObj]
        return arr[index].searchCont?.[key]
    }


    useEffect(() => {
        const arr = [...tabDataObj]
        const index = approvalType.findIndex((type) => type.id === Number(curTab))
        arr[index].searchCont = {
            ...arr[index].searchCont,
            [searchedColumn]: searchText
        }
        setTabDataObj([...arr])
    }, [searchText, searchedColumn, curTab])


    const handleSearch = (
        selectedKeys: string[],
        // eslint-disable-next-line no-unused-vars
        confirm: (param?: FilterConfirmProps) => void,
        name: string
    ) => {
        confirm()
        setSearchText(selectedKeys[0])
        setSearchedColumn(name)
    }

    const handleReset = (clearFilters: () => void, columnName?: string) => {
        clearFilters()
        setSearchText('')

        // 清空 tabDataObj 中对应列的搜索内容
        const targetColumn = columnName || searchedColumn
        if (targetColumn) {
            const arr = [...tabDataObj]
            const index = approvalType.findIndex((type) => type.id === Number(curTab))
            if (arr[index].searchCont) {
                delete arr[index].searchCont[targetColumn]
                setTabDataObj([...arr])
            }
            // 如果重置的是当前搜索的列，也要清空 searchedColumn
            if (targetColumn === searchedColumn) {
                setSearchedColumn('')
            }
        }

        setRefreshUuid(getUuid(8))
    }

    const getColumnSearchProps = (name: string): ColumnTypes[number] & IColProperty => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={t('search')}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, name)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, name)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        {t('search')}
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters, name)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        {t('reset')}
                    </Button>

                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        filteredValue: getSearchByKey(name) ? [getSearchByKey(name).toString()] : null,
    })

    const allColumns: (ColumnTypes[number] & IColProperty)[] =
        [
            {
                title: () => <span>{t('proposalName')}</span>,
                dataIndex: 'proposalName',
                key: 'proposalName',
                width: 400,
                ellipsis: { showTitle: true },
                fixed: 'left',
                render(value: string, record: any) {
                    if (Reflect.has(record, 'parent') && record.parent === null) {
                        return <span>{value}</span>
                    } else {
                        return (
                            <>
                                <Tag color="error" style={{ marginRight: 4 }}>{t('secondReview')}</Tag>
                                <span>{value}</span>
                            </>
                        )
                    }
                },
                ...getColumnSearchProps('proposalName'),

            },
            {
                title: () => <span>{t('Action')}</span>,
                dataIndex: 'operation',
                key: 'operation',
                width: 210,
                fixed: 'left',
                render: viewButton,
                filteredValue: null,
            },
            {
                title: () => <span>{t('creator')}</span>,
                dataIndex: 'creator',
                key: 'creator',
                width: 200,
                ellipsis: { showTitle: true },
                ...getColumnSearchProps('creator'),
            },
            {
                title: () => <span>{t('Work Group')}</span>,
                dataIndex: 'workGroup',
                key: 'workgroup',
                width: 200,
                ellipsis: { showTitle: true },
                render(value: any) {
                    return value.workGroupName
                },
                filters: workgroupList.map(i => ({
                    text: i.groupName,
                    value: i.id.toString(),
                })),
                filteredValue: getSearchByKey('workGroupId') ? [getSearchByKey('workGroupId').toString()] : null,
                filterMultiple: false,
            },
            {
                title: () => <span>{t('reviewResult')}</span>,
                dataIndex: 'reviewResult',
                key: 'reviewResult',
                width: 150,
                render: (value: boolean, record: any) => {
                    return value === null
                        ? t('reviewResultNull')
                        : value
                            ? t('reviewResultTrue')
                            :
                            <Popover content={record?.rejectReason || t('empty')} title={t('reviewResult')}>
                                {t('reviewResultFalse')} <QuestionCircleTwoTone />
                            </Popover>
                },

                filters: [
                    {
                        text: t('reviewResultNull'),
                        value: null as any,
                    }, {
                        text: t('reviewResultTrue'),
                        value: true as any,
                    },
                    {
                        text: t('reviewResultFalse'),
                        value: false as any,
                    }],
                filteredValue: [getSearchByKey('reviewResult')],
                filterMultiple: false,
            },
            // {
            //     title: () => (
            //         <span>
            //             {t('isApply') +
            //                 (i18n.language !== 'zh' ? ' ' : '') +
            //                 t('isDisruptive')}
            //         </span>
            //     ),
            //     dataIndex: 'isDisruptive',
            //     key: 'isDisruptive',
            //     width: 150,
            //     render: (value: boolean) => {
            //         return value ? t('Yes') : t('No')
            //     },
            //     filteredValue: null,
            // },
            // {
            //     title: () => <span>{t('isDisruptiveResult') + t('reviewResult')}</span>,
            //     dataIndex: 'disruptiveReview',
            //     key: 'disruptiveReview',
            //     width: 120,
            //     render: (value: number, record: any) => {
            //         return !record.isDisruptive
            //             ? 'NA'
            //             : record.reviewResult == null || value == null
            //                 ? 'NA'
            //                 : value >= 6
            //                     ? t('Yes')
            //                     : t('No')
            //     },
            //     filteredValue: null,
            // },
            // {
            //     title: () => (
            //         <span>
            //             {t('isApply') + (i18n.language !== 'zh' ? ' ' : '') + t('isCross')}
            //         </span>
            //     ),
            //     dataIndex: 'isCross',
            //     key: 'isCross',
            //     width: 150,
            //     // ellipsis: { showTitle: true },
            //     render: (value: boolean) => {
            //         return value ? t('Yes') : t('No')
            //     },
            //     filteredValue: null,
            // },
            // {
            //     title: () => (
            //         <span>
            //             {t('isCrossResult') +
            //                 (i18n.language !== 'zh' ? ' ' : '') +
            //                 t('reviewResult')}
            //         </span>
            //     ),
            //     dataIndex: 'isCrossReview',
            //     key: 'isCrossReview',
            //     width: 120,
            //     // ellipsis: { showTitle: true },
            //     render: (value: boolean, record: any) => {
            //         return !record.isCross
            //             ? 'NA'
            //             : record.reviewResult == null || value == null
            //                 ? 'NA'
            //                 : value
            //                     ? t('Yes')
            //                     : t('No')
            //     },
            //     filteredValue: null,
            // },
            {
                title: () => (
                    <span>
                        {t('reviewMeeting') + (i18n.language !== 'zh' ? ' ' : '') + t('time')}
                    </span>
                ),
                dataIndex: 'reviewDate',
                key: 'reviewDate',
                width: 200,
                ellipsis: { showTitle: true },
                render: (value: Date, record: any) => {
                    return (
                        moment(value).format('YYYY-MM-DD') +
                        (record.reviewDateHours ? ' ' + record.reviewDateHours : '')
                    )
                },
                filteredValue: null,
            },
            {
                title: () => <span>{t('feedDueDate')}</span>,
                dataIndex: 'tmtReviewDueDate',
                key: 'tmtReviewDueDate',
                width: 150,
                ellipsis: { showTitle: true },
                render: (value: Date) => {
                    return moment(value).format('YYYY-MM-DD')
                },
                filteredValue: null,
            },
            {
                title: () => <span>{t('feedEndDate')}</span>,
                dataIndex: 'dueDate',
                key: 'dueDate',
                width: 150,
                ellipsis: { showTitle: true },
                render: (value: Date) => {
                    return moment(value).format('YYYY-MM-DD')
                },
                filteredValue: null,
            },
            {
                title: () => <span>{t('technologicalLeadership')}</span>,
                dataIndex: 'technologyLeadership',
                key: 'technologyLeadership',
                width: 150,
                ellipsis: { showTitle: true },
                render(value: number) {
                    return findLabel(technologicalLeadershipArr.current, value)
                },
                filters: technologicalLeadershipArr.current.map(i => ({
                    text: i.label,
                    value: i.id as any
                })),
                filteredValue: getSearchByKey('technologyLeadership') ? [getSearchByKey('technologyLeadership').toString()] : null,
                filterMultiple: false,
            },
            {
                title: () => <span>{t('technicalContribution')}</span>,
                dataIndex: 'technologyContribution',
                key: 'technologyContribution',
                width: 150,
                ellipsis: { showTitle: true },
                render(value: number) {
                    return findLabel(technicalContributionArr.current, value)
                },
                filters: technicalContributionArr.current.map(i => ({
                    text: i.label,
                    value: i.id as any
                })),
                filteredValue: getSearchByKey('technologyContribution') ? [getSearchByKey('technologyContribution').toString()] : null,
                filterMultiple: false,
            },
            {
                title: () => <span>{t('techType')}</span>,
                dataIndex: 'coreTechnology',
                key: 'coreTechnology',
                width: 150,
                ellipsis: { showTitle: true },
                render(value: number) {
                    return labelArr[value]
                },
                filters: labelArr.map((i, idx) => ({
                    text: i,
                    value: idx as any
                })),
                filteredValue: getSearchByKey('coreTechnology') ? [getSearchByKey('coreTechnology').toString()] : null,
                filterMultiple: false,
            },
            {
                title: () => <span>{t('attach')}</span>,
                dataIndex: 'files',
                key: 'files',
                width: 250,
                ellipsis: { showTitle: true },
                render: viewAttach,
                filteredValue: null,
            },
        ]

    const goAddTechReview = () => {
        history.push(`/techReviewAdd?type=${curTab}`)
    }

    const onChangeTabs = (activeKey: string) => {
        console.log('activeKey: ', activeKey, typeof activeKey)
        setCurTab(activeKey)
        localStorage.setItem('curTab', activeKey)
        setRoutes([
            routes[0],
            {
                path: '/techReviewProgress',
                breadcrumbName: approvalType[Number(activeKey) - 1].label,
            },
        ])
    }


    // 修改评审结果提交
    const handleReviewResultSubmit = async () => {
        try {
            if (modalLoading) return
            setModalLoading(true)
            await updateReviewResult({
                id: curReviewResValue.id,
                reviewResult: curReviewResValue.reviewResult
            })
            setRefreshUuid(getUuid(8))
            setEditResultOpen(false)
        } catch (e: any) {
            const str = getErrorStr(e)
            dispatch(requestFail(str))
        } finally {
            setModalLoading(false)
        }
    }

    // 导出excel
    const onExportExcel = async () => {
        const res = await exportReviewExcel()
        downloadFile(res, t('reviewInfomation') + '.' + res.suffix)
    }
    const onExportContributionExcel = async () => {
        const res = await exportContributionExcel({ reviewType: Number(curTab) })
        downloadFile(res, 'contribution_data.' + res.suffix)
    }

    const onDownloadTemplate = async () => {
        const res = await getFileList('reviewTemplate4')
        const fileId = res.content?.[0].id
        if (fileId) {
            const fileRes = await getFile(fileId)
            downloadFile(
                fileRes,
                decodeURIComponent(fileRes.fileName) + '.' + fileRes.suffix
            )
        }
    }
    // 导出评审结论excel
    const onExportReviewInfoExcel = async () => {
        try {
            if (exportLoading) return
            setExportLoading(true)
            const res = await exportReviewInfoExcel(Number(curTab))
            downloadFile(res, t('reviewResultExcel') + '.' + res.suffix)
        } catch (e: any) {
            const str = getErrorStr(e)
            dispatch(requestFail(str))
        } finally {
            setExportLoading(false)
        }

    }

    const handleTableChange = (pagination: PaginationProps, filters: any, sorter: any) => {
        console.log(pagination, filters, sorter)
        const arr = [...tabDataObj]
        const index = approvalType.findIndex((type) => type.id === Number(curTab))
        arr[index].searchCont = {
            ...arr[index].searchCont,
            workGroupId: filters.workgroup?.[0],
            reviewResult: filters.reviewResult?.[0],
            technologyLeadership: filters.technologyLeadership?.[0],
            technologyContribution: filters.technologyContribution?.[0],
            coreTechnology: filters.coreTechnology?.[0],
        }
        arr[index].paginationInfo = {
            ...arr[index].paginationInfo,
            pageNo: pagination.current || 1,
            pageSize: pagination.pageSize || 10,
        }
        setTabDataObj([...arr])
        setRefreshUuid(getUuid(8))
    }

    // // 分页
    // const onPaginationChange: PaginationProps['onChange'] = (
    //     pageNumber: number
    // ): void => {
    //     console.log('onPaginationChange')
    //     if (pageSizeChanged.current) return
    //     const arr = [...tabDataObj]
    //     const index = approvalType.findIndex((type) => type.id === Number(curTab))
    //     arr[index].paginationInfo = {
    //         ...arr[index].paginationInfo,
    //         pageNo: pageNumber,
    //     }
    //     setTabDataObj([...arr])
    //     setRefreshUuid(getUuid(8))
    // }
    // const onPageSizeChange = (current: number, size: number) => {
    //     // 避免重复触发 pageChange 事件
    //     pageSizeChanged.current = true
    //     const arr = [...tabDataObj]
    //     const index = approvalType.findIndex((type) => type.id === Number(curTab))
    //     arr[index].paginationInfo = {
    //         ...arr[index].paginationInfo,
    //         pageNo: 1,
    //         pageSize: size,
    //     }
    //     setTabDataObj([...arr])
    //     setRefreshUuid(getUuid(8))
    //     setTimeout(() => {
    //         pageSizeChanged.current = false
    //     }, 100)
    // }

    const isCTStaff = useMemo(() => {
        return userInfo?.bu?.includes('CT')
    }, [userInfo])

    const getLs = async () => {
        try {
            const index = approvalType.findIndex(
                (type) => type.id === Number(curTab)
            )
            // Try to restore state from sessionStorage
            const savedState = sessionStorage.getItem('techReviewTabData')
            let arr = _.cloneDeep(tabDataObj)
            if (savedState) {
                const { tabDataObj: savedTabDataObj } = JSON.parse(savedState)
                arr = [...savedTabDataObj]
                sessionStorage.removeItem('techReviewTabData')
            }
            setLoaded(false)
            const res = await getOnlineReview({
                ...arr[index].searchCont,
                isReviewing: arr[index].searchCont.reviewResult === null ? 1 : null,
                pageNo: arr[index].paginationInfo.pageNo,
                pageSize: arr[index].paginationInfo.pageSize,
                reviewType: Number(curTab),
            })
            setLoaded(true)

            if (!res || !Array.isArray(res.content)) {
                arr[index].onlineReviewLs = []
                arr[index].paginationInfo = {
                    ...arr[index].paginationInfo,
                    total: 0,
                }
                setTabDataObj(arr)
                return
            }

            arr[index].paginationInfo = {
                ...arr[index].paginationInfo,
                total: res.totalElements || 0,
            }

            const processedContent = (res.content || []).map((item: any) => {
                if (!item) return null
                const { parent } = item
                if (!parent) {
                    return item
                }
                return {
                    ...item,
                    children: [parent]
                }
            }).filter(Boolean)
            console.log(processedContent,'processedContent')

            arr[index].tableKey = getUuid(8)
            arr[index].onlineReviewLs = processedContent
            setTabDataObj(arr)
            setTabData({
                ...tabData,
                [`tab${curTab}`]: true,
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
            // 发生错误时设置空数组
            const index = approvalType.findIndex(
                (type) => type.id === Number(curTab)
            )
            const arr = _.cloneDeep(tabDataObj)
            arr[index].onlineReviewLs = []
            arr[index].paginationInfo = {
                ...arr[index].paginationInfo,
                total: 0,
            }
            setTabDataObj(arr)
        }
    }

    const searchCloseCallback = async (values: any) => {
        const index = approvalType.findIndex((type) => type.id === Number(curTab))
        const arr = [...tabDataObj]
        arr[index].searchCont = values
        arr[index].tableKey = getUuid(8)
        arr[index].paginationInfo = {
            ...arr[index].paginationInfo,
            pageNo: 1,
        }
        setTabDataObj([...arr])
        setRefreshUuid(getUuid(8))
    }

    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/techReviewProgress',
            breadcrumbName: t('technicalReviewProcess'),
        },
    ])
    useEffect(() => {
        const h = 338
        setWinW(document.body.clientWidth)
        setWinh(document.body.clientHeight - h)
        window.onresize = () => {
            setWinW(document.body.clientWidth)
            setWinh(document.body.clientHeight - h)
        }
        return () => {
            window.onresize = null
        }
    }, [])
    useEffect(() => {
        if (refreshUuid !== '1') {
            getLs()
        }
    }, [refreshUuid])


    useEffect(() => {
        console.log('curTab: ', curTab, typeof curTab)
        if (!tabData[`tab${curTab}`]) {
            getLs()
        }
    }, [curTab])

    const columns = useMemo(() => {

        // 初始化一个包含四个空数组的数组（对应四个标签页）
        const columnsTemp: (ColumnTypes[number] & IColProperty)[][] = [[], [], [], []]
        // 确保 tabData 和 allColumns 存在
        if (!allColumns || !tabData) return columnsTemp
        // 获取当前标签页的索引
        const tabIndex = Number(curTab) - 1
        if (tabIndex < 0 || tabIndex > 3) return columnsTemp

        // 获取当前标签页的数据
        const currentTabData = tabData[`tab${curTab}`]
        if (!currentTabData) return columnsTemp

        // 过滤列
        const columnArr = _.cloneDeep(allColumns).filter((c: any) => {
            if (
                c.key === 'technologyLeadership' ||
                c.key === 'technologyContribution' ||
                c.key === 'coreTechnology'
            ) {
                return curTab !== '1'
            } else if (c.key === 'tmtReviewDueDate' || c.key === 'dueDate') {
                return curTab !== '4'
            } else {
                return true
            }
        })



        // 设置筛选值
        columnArr.forEach((column: any) => {
            if (column.key === 'workgroup') {
                const value = getSearchByKey('workGroupId')
                column.filteredValue = value ? [value.toString()] : null
            } else if (column.key === 'reviewResult') {
                const value = getSearchByKey('reviewResult')
                column.filteredValue = value !== undefined ? [value] : null
            } else if (column.key === 'technologyLeadership') {
                const value = getSearchByKey('technologyLeadership')
                column.filteredValue = value ? [value.toString()] : null
            } else if (column.key === 'technologyContribution') {
                const value = getSearchByKey('technologyContribution')
                column.filteredValue = value ? [value.toString()] : null
            } else if (column.key === 'coreTechnology') {
                const value = getSearchByKey('coreTechnology')
                column.filteredValue = value ? [value.toString()] : null
            }
            // 对于其他列，保持它们原有的 filteredValue（通常是 null）
        })
        // 更新当前标签页的列
        columnsTemp[tabIndex] = columnArr
        return columnsTemp
    }, [allColumns, tabData, curTab, tabDataObj]) // 添加所有相关依赖项

    const tabExtraContent = useMemo(() => (
        <Space>
            {/* 新增提案申请 */}
            {validateAuthByKey('techReviewAdd') && (
                <Button
                    icon={<PlusOutlined />}
                    type="primary"
                    disabled={isCTStaff && curTab === '4'}
                    onClick={goAddTechReview}
                >
                    {t('add')}
                </Button>
            )}
            <Dropdown
                overlay={
                    <Menu>
                        <Menu.Item
                            key="normalSearch"
                            onClick={() => setShowSearchPop(!showSearchPop)}
                        >
                            {t('search')}
                        </Menu.Item>
                        <Menu.Item
                            key="aiSearch"
                            onClick={() => setAiSearchDrawerOpen(true)}
                        >
                            {t('ai search')}
                        </Menu.Item>
                    </Menu>
                }
                trigger={['click']}
            >
                <Button type="primary" icon={<SearchOutlined />}>
                    {t('search')} <span style={{ marginLeft: 4 }}></span>
                </Button>
            </Dropdown>
            <Dropdown
                overlay={
                    <Menu>
                        <Menu.Item
                            key="downloadTemplate"
                            onClick={onDownloadTemplate}
                        >
                            {t('techIssues') +
                                (i18n.language !== 'zh' ? ' ' : '') +
                                t('templateDownload')}
                        </Menu.Item>
                    </Menu>
                }
                trigger={['click']}
            >
                <Button type="primary" icon={<DownloadOutlined />}>
                    {t('download')} <span style={{ marginLeft: 4 }}></span>
                </Button>
            </Dropdown>
            <Dropdown
                overlay={
                    <Menu>
                        <Menu.Item
                            key="exportReviewInfo"
                            onClick={onExportExcel}
                        >
                            {t('export') +
                                (i18n.language !== 'zh' ? ' ' : '') +
                                t('reviewInfomation')}
                        </Menu.Item>
                        <Menu.Item
                            key="exportReviewResult"
                            // icon={<CloudDownloadOutlined />}
                            onClick={onExportReviewInfoExcel}
                            disabled={exportLoading}
                        >
                            {t('export') +
                                (i18n.language !== 'zh' ? ' ' : '') +
                                t('reviewResultExcel')}
                        </Menu.Item>
                        {curTab === '3' && (
                            <Menu.Item
                                key="exportContribution"
                                onClick={onExportContributionExcel}
                            >
                                {t('export') +
                                    (i18n.language !== 'zh' ? ' ' : '') +
                                    t('contribution degree')}
                            </Menu.Item>
                        )}
                    </Menu>
                }
                trigger={['click']}
            >
                <Button type="primary" icon={<ExportOutlined />}>
                    {t('export')} <span style={{ marginLeft: 4 }}></span>
                </Button>
            </Dropdown>
        </Space>
    ), [curTab, onExportExcel, onExportReviewInfoExcel, onExportContributionExcel, isCTStaff, validateAuthByKey, showSearchPop, goAddTechReview, exportLoading])



    const searchForm: ISearchData = useMemo(() => {
        const index = approvalType.findIndex(
            (type) => type.id === Number(curTab)
        )
        const arr = [...tabDataObj]
        const workGroupId = arr[index].searchCont?.workGroupId
        return {
            workGroupId: typeof workGroupId === 'string' ? Number(workGroupId) : workGroupId,
            creator: arr[index].searchCont?.creator,
            reviewResult: arr[index].searchCont?.reviewResult,
            technologyLeadership: arr[index].searchCont?.technologyLeadership,
            technologyContribution: arr[index].searchCont?.technologyContribution,
            coreTechnology: arr[index].searchCont?.coreTechnology,
        }
    }, [curTab, tabDataObj])

    return (
        (<Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb
                routerParam={routes}
                history={history}
                dispatch={dispatch}
            />
            <Space direction="vertical" style={{ padding: 16, width: '100%' }}>
                <Space direction="vertical" style={{ width: '100%', paddingBottom: 0 }}>

                    <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
                        <Tabs
                            className="tabs_head_mb"
                            type="card"
                            defaultActiveKey={curTab}
                            tabPosition="top"
                            onChange={onChangeTabs}
                            tabBarExtraContent={tabExtraContent}
                        >
                            {approvalType.map((_, i) => (
                                <TabPane tab={approvalType[i].label} key={approvalType[i].id}>
                                    {tabDataObj.length > i ? (
                                        <ResizableTable
                                            bordered
                                            key={curTab}
                                            loading={curTab === String(i + 1) ? !loaded : false}
                                            cols={columns[Number(curTab) - 1]}
                                            tableData={tabDataObj[i].onlineReviewLs}
                                            defaultExpandAllRows={true}
                                            rowKey="id"
                                            onChange={handleTableChange}
                                            scroll={{ y: winH }} // 可拖动时不能设置 x: 'max-content'
                                            pagination={{
                                                current: tabDataObj[i].paginationInfo.pageNo,
                                                pageSize: tabDataObj[i].paginationInfo.pageSize,
                                                total: tabDataObj[i].paginationInfo.total,
                                                showQuickJumper: true,
                                                // onChange: onPaginationChange,
                                                showSizeChanger: true,
                                                // onShowSizeChange: onPageSizeChange,
                                                showTotal: (total: number) =>
                                                    `${t('total')} ${total} ${t('items')}`,
                                            }}
                                        />
                                    ) : (
                                        <Empty />
                                    )}
                                </TabPane>
                            ))}
                        </Tabs>
                    </ConfigProvider>
                    <SelectProject
                        show={showSelectProjects}
                        setShow={setShowSelectProjects}
                        confirm={selectProjectCallBack}
                        defaultValue={''}
                        selection={selectedProject.project_select}
                    />
                </Space>
            </Space>
            <DrawerShowContext.Provider
                value={{
                    showSearchPop,
                    setShowSearchPop,
                    closeCallback: searchCloseCallback,
                    formData: searchForm
                }}
            >
                <ReviewSearchPop />
            </DrawerShowContext.Provider>
            <ReviewLogs data={curReviewResValue} id={curReviewResValue?.id} open={logDrawerOpen} setDrawerOpen={(value: boolean) => {
                setLogDrawerOpen(value)
            }} />
            <ReviewProgress data={curReviewResValue} open={progressDrawerOpen} setDrawerOpen={(value: boolean) => {
                setProgressDrawerOpen(value)
            }} />
            <AiSearchDrawer open={aiSearchDrawerOpen} setOpen={(value: boolean) => {
                setAiSearchDrawerOpen(value)
            }} />
            <Modal title={joinTranslatedStrings(t('edit'), t('reviewResult'))}
                open={editResultOpen}
                onCancel={() => {
                    setEditResultOpen(false)
                }}
                onOk={handleReviewResultSubmit}
                okText={t('confirm')}
                okButtonProps={{ loading: modalLoading }}
            >
                <div>
                    <Radio.Group onChange={(e) => {
                        setCurReview({
                            ...curReviewResValue,
                            reviewResult: e.target.value
                        })
                    }} value={curReviewResValue.reviewResult}>
                        <Radio value={null}>{t('reviewResultNull')}</Radio>
                        <Radio value={true}>{t('reviewResultTrue')}</Radio>
                        <Radio value={false}>{t('reviewResultFalse')}</Radio>
                    </Radio.Group>
                </div>
            </Modal>
        </Space>)
    );
})

export default TechReviewProgressPage
